import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import {
  CalendarToday as CalendarIcon,
  ContactSupport as HelpIcon,
  Dashboard as DashboardIcon,
  Search as InsightIcon,
  Description as DescriptionIcon,
  Kitchen as KitchenIcon,
} from '@material-ui/icons';
import React from 'react';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    borderRight: `1px solid ${theme.palette.divider}`,
    height: '100%',
  },
  listItem: {
    textDecoration: 'none',
    color: 'black',
  },
}));

export const DashboardDrawer = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.drawer} square elevation={0}>
      <List>
        <Link to="/dashboard" className={classes.listItem}>
          <ListItem button key="Dashboard" to={'dashboard'}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
        </Link>
        <Link to="/dashboard/kitchen" className={classes.listItem}>
          <ListItem button key="DeWaste Kitchen" to={'kitchen'}>
            <ListItemIcon>
              <KitchenIcon />
            </ListItemIcon>
            <ListItemText primary="Kitchen" />
          </ListItem>
        </Link>
        <Link to="/dashboard/calendar" className={classes.listItem}>
          <ListItem button key="calendar" to={'calendar'}>
            <ListItemIcon>
              <CalendarIcon />
            </ListItemIcon>
            <ListItemText primary="Meal Timings" />
          </ListItem>
        </Link>
        <Link to="/dashboard/insights" className={classes.listItem}>
          <ListItem button>
            <ListItemIcon>
              <InsightIcon />
            </ListItemIcon>
            <ListItemText primary="Insights" />
          </ListItem>
        </Link>
        <Link to="/dashboard/studentfeedback" className={classes.listItem}>
          <ListItem button>
            <ListItemIcon>
              <DescriptionIcon />
            </ListItemIcon>
            <ListItemText primary="Student Feedback" />
          </ListItem>
        </Link>
      </List>
      <Divider />
      <List>
        <Link to="/dashboard/help" className={classes.listItem}>
          <ListItem button key="Help">
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="Help" />
          </ListItem>
        </Link>
      </List>
    </Paper>
  );
};
